export const getFormattedPassportNumber = (documentType = '', documentNumber = '') => {
    if (documentType === 'Паспорт РФ') {
        return `${documentNumber.slice(0, 4)} ${documentNumber.slice(4)}`;
    }

    return documentNumber;
};
